import { render, staticRenderFns } from "./ClientBillingLedgerSidebar.vue?vue&type=template&id=1a886b02"
import script from "./ClientBillingLedgerSidebar.vue?vue&type=script&lang=js"
export * from "./ClientBillingLedgerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports